import { render, staticRenderFns } from "./photoLocation.vue?vue&type=template&id=0406e437&scoped=true"
import script from "./photoLocation.vue?vue&type=script&lang=js"
export * from "./photoLocation.vue?vue&type=script&lang=js"
import style0 from "./photoLocation.vue?vue&type=style&index=0&id=0406e437&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0406e437",
  null
  
)

export default component.exports